export const channel = {
  name: 'ПригодоМанія',
  handle: '@prygodomania',
  author: 'Карина Тумаєва',
  email: 'hello@prygodomania.com',
  url: 'https://www.youtube.com/@prygodomania',
  subscribeUrl: 'https://www.youtube.com/@prygodomania?sub_confirmation=1',
  description:
    'Привіт, я Карина Тумаєва, і я в захваті від нестандартних подорожей. Тут ви знайдете звіти про всі види моїх аутдорних активностей, серед яких походи по горах, скелелазіння та сноубординг.',
};

export const seo = {
  title: 'ПригодоМанія — походи Карпатами, скелелазіння та подорожі | YouTube-канал Карини Тумаєвої',
  description:
    'Відео-звіти про походи Карпатами на один і кілька днів: Ґорґани, Чорногора, Боржава, Говерла, Сивуля, Ігровець. Скелелазіння в Україні та за кордоном, маршрути з мапою. Дивіться та підписуйтесь на ПригодоМанію.',
  keywords:
    'походи Карпатами, похід на один день, Ґорґани, Чорногора, Боржава, Сивуля, Ігровець, Яремче, Буковель, скелелазіння, боулдерінг, маршрути Карпати, ПригодоМанія, Карина Тумаєва',
  tagline: 'Походи Карпатами, скелелазіння та подорожі',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/158d2e52-5a50-401c-8527-ca21a540138b.jpg',
  themeColor: '#0D1310',
};

export const channelStats = [
  { value: '1,08 тис.', label: 'підписників' },
  { value: '44', label: 'відео' },
  { value: '81 тис.', label: 'переглядів' },
];

export const channelFacts = [
  { label: 'На YouTube', value: 'з липня 2016' },
  { label: 'Звідки', value: 'Україна' },
  { label: 'Відео', value: '44 випуски' },
  { label: 'Переглядів', value: '81 066' },
];

export const activities = ['Походи по горах', 'Скелелазіння', 'Сноубординг'];
